export default () => {
  if (typeof window !== 'undefined') {
    const webUuidCookie = window.document.cookie
      .split(';')
      .map(s => s.trim())
      .find(s => s.startsWith('web_uuid='))
    if (typeof webUuidCookie === 'string') {
      const [, uuid = ''] = webUuidCookie.split('=')
      return uuid
    }
  }
  return ''
}
